var exports = {
  "Nr": "StreamSpectatorsPopout.module__card___OVNxU3",
  "wx": "StreamSpectatorsPopout.module__header___OVNxU3",
  "p_": "StreamSpectatorsPopout.module__list___OVNxU3",
  "QC": "StreamSpectatorsPopout.module__spectatorRow___OVNxU3",
  "zh": "StreamSpectatorsPopout.module__spectatorName___OVNxU3",
  "e": "StreamSpectatorsPopout.module__spectatorDevice___OVNxU3",
};

module.exports = exports;
